@if (product$ | async; as product) {
  <div>
    <cx-add-to-cart [productCode]="product.code ?? ''" [showQuantity]="false"></cx-add-to-cart>
  </div>
}
